interface ApiConfig {
	baseUrl: string;
	timeout: number;
	uploadTimeout: number;
}

export const apiConfig: ApiConfig = {
	baseUrl: import.meta.env.VITE_API_BASE_URL || "http://localhost:8000/api/v1",
	timeout: parseInt(import.meta.env.VITE_API_TIMEOUT || "10000", 10),
	uploadTimeout: parseInt(
		import.meta.env.VITE_API_UPLOAD_TIMEOUT || "60000",
		10,
	),
};
